import { IGetManutencaoByIdUseCase } from "../../../presentation/useCases/read/get_manutencao_by_id_use_case";
import { ManutencaoModel } from "../../models/manutencao_model";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetManutencaoByIdUseCase
 */

export class GetManutencaoByIdUseCase implements IGetManutencaoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(idManutencao: number): Promise<ManutencaoModel> {
    return this.repository.getManutencaoById(idManutencao);
  }
}
